import { LISCaseList } from "pwapi";

import { CASE_WITH_WORK_ACTIONS, LIS } from "shared/actions/constants";
import { PWAction } from "shared/utils/redux";

export type CasesState = { [key: number]: LISCaseList };

const casesWithWorkReducer = (
  state: CasesState = {},
  action: PWAction
): CasesState => {
  let json: any, _meta: any;

  if (CASE_WITH_WORK_ACTIONS.includes(action.type)) {
    ({ _meta, ...json } = action.payload.response);
    return {
      ...state,
      [json.id]: json,
    };
  }

  switch (action.type) {
    case LIS.ACCESSION.PRINT.SUCCESS:
      ({ _meta, ...json } = action.payload.response.created_case);
      return {
        ...state,
        [json.id]: json,
      };
    case LIS.CASE.LIST.SUCCESS:
      return action.payload.response.results.reduce(
        (newState: CasesState, json: LISCaseList) => {
          if (!json.id) return newState;
          newState[json.id] = json;
          return newState;
        },
        {}
      );
    case LIS.SPECIMEN.UPDATE.SUCCESS:
      json = action.payload.response;
      return state[json.case_id]
        ? {
            ...state,
            [json.case_id]: {
              ...state[json.case_id],
              specimens: [
                ...state[json.case_id].specimens.filter(
                  (s) => s.id !== json.id
                ),
                json,
              ],
            },
          }
        : state;
  }
  return state;
};

export default casesWithWorkReducer;
